import { appStateApi } from '@/api';
import { queryKeys } from '@/api/query-keys.ts';
import { AppState } from '@/api/app-state/app-state.types.ts';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

/**
 * Reads the public app state (maintenance + effective announcements). Polled and
 * refetched on focus so a freshly toggled maintenance mode or a new banner shows
 * up without a reload. Works without auth so it is usable on `/auth/*`.
 */
export const useAppState = (
  options?: Partial<UseQueryOptions<AppState, AxiosError>>,
) => {
  return useQuery<AppState, AxiosError>({
    queryKey: queryKeys.appState,
    queryFn: () => appStateApi.getAppState().then((res) => res.data),
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    staleTime: 30_000,
    ...options,
  });
};
